import React, {useEffect, useState, useRef} from "react";
import "./style.scss";
import SigninForm from "../../../components/Auth/SigninForm";
import {useSelector} from "react-redux";
import ErrorModal from "../../../reusableComponents/ErrorModal";
import {clearPersistedData} from "../../../store/configureStore";
import SuccessModal from "../../../components/reusableComponents/SuccessModal";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import AuthFrame from "../../../components/Auth/AuthFrame";
import SignupForm from "../../../components/Auth/SignupForm";
import ForgotPasswordForm from "../../../components/Auth/ForgotPasswordForm";
import ResetPasswordForm from "../../../components/Auth/ResetPasswordForm";
import PasswordOTPForm from "../../../components/Auth/PasswordOTPForm";
import WarningModal from "../../../components/Alerts/WarningModal/WarningModal";
import companyLogo from "../../../assets/icons/mobileMenuLogo.png";
import CryptoBrandIcon from "../../../assets/newIcons/cryptoLogo.svg";
import NewAuthLeft from "../../../components/Auth/NewAuthLeft/NewAuthLeft";

function Signin() {
  const [errormodalOpen, setErrorModalOpen] = useState(false);

  const [msg, setMsg] = useState("");
  const {theme} = useSelector((state) => state.theme);
  useEffect(() => {
    document.body.classList["value"] === "" && (document.body.classList = theme);
  }, [theme]);
  const authState = useSelector((state) => state.auth);
  useEffect(() => {
    setMsg(authState.message);
    setErrorModalOpen(authState.error);
  }, [authState]);

  useEffect(() => {
    clearPersistedData();
  }, []);

  const location = useLocation();
  const navigate = useNavigate();

  console.log("location", location);

  const [activeForm, setActiveForm] = useState("signin");

  // useEffect(() => {
  //   if (location.pathname.startsWith("/signup")) {
  //     setActiveForm("signup");
  //   } else if (location.pathname === "/forgot-password") {
  //     setActiveForm("forgot-password");
  //   } else if (location.pathname === "/password-otp") {
  //     setActiveForm("password-otp");
  //   } else if (location.pathname === "/reset-password") {
  //     setActiveForm("reset-password");
  //   } else {
  //     navigate("/signin");
  //   }
  // }, [location.pathname]);
  const [referalcode, setReferralCode] = useState("");

  useEffect(() => {
    setActiveForm(location.pathname?.replace("/", ""));
    setReferralCode(activeForm.split("/")[1]);
    document.querySelector(".authPageContainer").scrollTo({top: 0, behavior: "smooth"});
  }, [activeForm, location.pathname]);

  const toggleTabsRef = useRef({});
  const [toggleIndicatorStyle, setToggleIndicatorStyle] = useState({left: 0, width: 0, top: 0, height: 0, opacity: 0});

  useEffect(() => {
    const handleResize = () => setToggleIndicatorStyle((prev) => ({...prev}));
    window.addEventListener("resize", handleResize);

    const timer = setTimeout(() => {
      let currentTab = activeForm === "signin" ? "signin" : "signup";
      if (activeForm.startsWith("signup") || location.pathname.startsWith(`/signup/`)) currentTab = "signup";

      if (toggleTabsRef.current[currentTab]) {
        const el = toggleTabsRef.current[currentTab];
        setToggleIndicatorStyle({left: el.offsetLeft, width: el.offsetWidth, top: el.offsetTop, height: el.offsetHeight, opacity: 1});
      }
    }, 50);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, [activeForm, location.pathname]);

  console.log("activeForm", activeForm);

  const message = location.state?.message;
  const [openModal, setOpenModal] = useState(message && true);
  return (
    <div className="authPageContainer login_page_container">
      <div className="authPageWrapper login_page_container">
        {" "}
        <div className="login_page_left">
          {/* <AuthFrame /> */}
          <NewAuthLeft />
        </div>
        {/* <span style={{fontSize: "40px", fontWeight: "900"}}>/</span>

          <img
            src={CryptoBrandIcon}
            alt="CryptoBrandIcon"
          /> */}
        <div className={`login_right  ${activeForm.startsWith("signup") ? "signupLoginFormContainer" : ""}`}>
          <div className="mobileLogo">
            <img
              src={companyLogo}
              alt=""
            />
          </div>
          <div className={`loginFormContainer`}>
            <div className="titleSection">
              {activeForm === "signin" ? (
                <h3>Welcome Back</h3>
              ) : activeForm === "signup" || location.pathname === `/signup/${referalcode}/` ? (
                <h3>Create Account</h3>
              ) : activeForm === "forgot-password" ? (
                <div className="TitleDiv">
                  <h3>Forgot Password</h3>
                  <p>Please enter the email address associated with your account</p>
                </div>
              ) : (
                ""
              )}

              {activeForm === "password-otp" ? (
                <div className="TitleDiv">
                  <h3>Enter 6 digit Code</h3>
                  <p>Enter the code from your Email</p>
                </div>
              ) : activeForm === "reset-password" ? (
                <div className="TitleDiv">
                  <h3>Reset Password</h3>
                  <p>Let's reset your new password</p>
                </div>
              ) : (
                ""
              )}

              {activeForm !== "forgot-password" && activeForm !== "password-otp" && activeForm !== "reset-password" && (
                <div
                  className="buttonSection"
                  style={{position: "relative", zIndex: 1}}
                >
                  <div
                    className="sliding-indicator"
                    style={{...toggleIndicatorStyle, background: "var(--brand-primary, #36d66b)"}}
                  />
                  <button
                    ref={(el) => (toggleTabsRef.current["signin"] = el)}
                    style={{position: "relative", zIndex: 2}}
                    className={`formButtonSection ${activeForm === "signin" ? "activeFormBtn" : ""}`}
                    onClick={() => navigate("/signin")}
                  >
                    Sign In
                  </button>
                  <button
                    ref={(el) => (toggleTabsRef.current["signup"] = el)}
                    style={{position: "relative", zIndex: 2}}
                    className={`formButtonSection ${activeForm === "signup" || location.pathname === `/signup/${referalcode}/` ? "activeFormBtn" : ""}`}
                    onClick={() => navigate("/signup")}
                  >
                    Sign Up
                  </button>
                </div>
              )}
            </div>
            {activeForm === "signin" ? (
              <SigninForm />
            ) : activeForm === "signup" || location.pathname === `/signup/${referalcode}/` ? (
              <SignupForm referalcode={referalcode} />
            ) : activeForm === "forgot-password" ? (
              <ForgotPasswordForm />
            ) : activeForm === "password-otp" ? (
              <PasswordOTPForm />
            ) : activeForm === "reset-password" ? (
              <ResetPasswordForm />
            ) : (
              ""
            )}
          </div>
        </div>
        {message && openModal && (
          <SuccessModal
            setModalOpen={() => setOpenModal(false)}
            title="Successful!"
            desc={message}
            btnText="Close"
          />
        )}
        {/* <WarningModal /> */}
      </div>
    </div>
  );
}

export default Signin;
